<template>
  <v-dialog
    v-model="dialog"
    @input="$emit('update:dialog', false)"
    @keydown.esc="closeDialog()"
    width="600px"
  >
    <v-card>
      <v-card-title class="pb-0">
        <span class="headline">{{ $t('user.login') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-text-field
            :label="$t('theme.login.username')"
            v-model="login.username"
            :rules="[v => !!v || $t('field.required')]"
            required
          ></v-text-field>
          <v-text-field
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            :label="$t('theme.login.password')"
            v-model="login.password"
            min="8"
            :rules="[v => !!v || $t('field.required')]"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">{{ $t('btn.cancel') }}</v-btn>
        <v-btn color="primary" @click="onLogin()" :class=" { 'white--text' : valid, disabled: !valid }">{{ $t('btn.login') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'auth-login',
  data () {
    return {
      valid: false,
      submitLoading: false,
      showPassword: false,
      login: {
        username: '',
        password: ''
      }
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog(){
      this.$emit('update:dialog', false)
    },

    onLogin () {
      if (this.$refs.form.validate()) {
        this.$emit('onClickLogin', this.login)
      }
    }

  }
}
</script>
